<button
   #button
   mat-icon-button
   type="button"
   [attr.aria-haspopup]="dateTimePicker ? 'dialog' : null"
   aria-label="Open Calendar/Clock"
   [attr.tabindex]="disabled ? -1 : 0"
   [disabled]="disabled"
   [disableRipple]="disableRipple"
   (click)="open($event)"
>
   <mat-icon class="lcs-date-time-picker-toggle-icon">today</mat-icon>
</button>
